import { Dropdown, DropdownButton, DropdownItem, DropdownLabel, DropdownMenu, MenubarItem } from '@criteria-labs/react'
import { parse as parsePath } from 'path'
import { useSyncExternalStore } from 'react'
import yaml from 'yaml'
import { useActiveDocument } from '../../document-view/useActiveDocument'
import { FileDocument } from '../../documents/FileDocument'
import { JSONDocument } from '../../documents/JSONDocument'
import { ProjectManager } from '../ProjectManager'
import { useProjectSelection } from '../selection/useProjectSelection'

function EditMenuItems({ document }: { document: FileDocument }) {
  const { select } = useProjectSelection()

  const { name } = parsePath(document.path)

  const data = useSyncExternalStore(
    (onStoreChange) => {
      document.addListener(onStoreChange)
      return () => document.removeListener(onStoreChange)
    },
    () => (document instanceof JSONDocument ? document.data : null)
  )
  const format = useSyncExternalStore(
    (onStoreChange) => {
      document.addListener(onStoreChange)
      return () => document.removeListener(onStoreChange)
    },
    () => (document instanceof JSONDocument ? document.format : null)
  )

  return (
    <DropdownMenu anchor="bottom start" modal={false}>
      {document instanceof JSONDocument && data && format === 'json' && (
        <DropdownItem
          onClick={async () => {
            const yamlText = yaml.stringify(data)
            const newName = `${name}.yaml`
            await document.updateText(yamlText)

            const item = ProjectManager.shared().findItemWithPath(document.path)
            if (!item) {
              return
            }

            try {
              ProjectManager.shared().renameItemSync(item, newName, (renamedItem) => {
                select(renamedItem.path, false)
              })
            } catch (error) {
              console.error(error)
            }
          }}
        >
          <DropdownLabel>Convert to YAML</DropdownLabel>
        </DropdownItem>
      )}
      {document instanceof JSONDocument && data && format === 'yaml' && (
        <DropdownItem
          onClick={async () => {
            const jsonText = JSON.stringify(data, null, '  ')
            const newName = `${name}.json`
            await document.updateText(jsonText)

            const item = ProjectManager.shared().findItemWithPath(document.path)
            if (!item) {
              return
            }

            try {
              ProjectManager.shared().renameItemSync(item, newName, (renamedItem) => {
                select(renamedItem.path, false)
              })
            } catch (error) {
              console.error(error)
            }
          }}
        >
          <DropdownLabel>Convert to JSON</DropdownLabel>
        </DropdownItem>
      )}
    </DropdownMenu>
  )
}

export function EditMenu() {
  // TODO: Edit Menu should operate on file, not document
  const activeDocument = useActiveDocument()

  return (
    <Dropdown>
      <DropdownButton as={MenubarItem} disabled={!activeDocument}>
        Edit
      </DropdownButton>
      {activeDocument && <EditMenuItems document={activeDocument} />}
    </Dropdown>
  )
}
